import { schema } from 'normalizr'

const DeliverySchema = new schema.Entity('deliveries')

export default DeliverySchema
